export default "__VITE_ASSET__B4ju86AN__"